import { motion } from "framer-motion";
import { useState } from "react";
import { Copy, Check } from "lucide-react";

const EMAIL = "sssmokeylion@gmail.com";

export const Contact = () => {
  const [copied, setCopied] = useState(false);

  const copyEmail = async (e) => {
    e.preventDefault();
    try {
      await navigator.clipboard.writeText(EMAIL);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      window.location.href = `mailto:${EMAIL}`;
    }
  };

  return (
    <footer
      id="contact"
      data-testid="contact-section"
      className="relative px-6 py-24 md:px-10 md:py-40"
    >
      <div className="mx-auto max-w-7xl">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-10 font-mono-accent text-xs uppercase tracking-[0.25em] text-zinc-500"
        >
          / Get in touch
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="max-w-2xl text-lg leading-relaxed text-zinc-400">
            Questions about a drop, a bulk order, or a collab? Reach out — I read
            every message.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-6">
            <a
              href={`mailto:${EMAIL}`}
              data-testid="contact-email-link"
              className="group font-display text-4xl font-extrabold tracking-tighter text-white transition-colors duration-300 hover:text-[#ccff00] sm:text-6xl md:text-7xl lg:text-8xl"
            >
              {EMAIL}
            </a>
          </div>

          <button
            onClick={copyEmail}
            data-testid="contact-copy-email"
            className="mt-8 inline-flex items-center gap-3 rounded-full border border-white/20 px-6 py-3 font-mono-accent text-xs uppercase tracking-[0.15em] text-white transition-colors duration-300 hover:border-[#ccff00] hover:text-[#ccff00]"
          >
            {copied ? (
              <>
                <Check className="h-4 w-4" /> Copied
              </>
            ) : (
              <>
                <Copy className="h-4 w-4" /> Copy email
              </>
            )}
          </button>
        </motion.div>

        {/* Legal disclaimer */}
        <div
          data-testid="legal-disclaimer"
          className="mt-16 rounded-2xl border border-white/10 bg-white/[0.02] p-6 md:p-8"
        >
          <p className="mb-3 font-mono-accent text-xs uppercase tracking-[0.2em] text-[#ccff00]">
            Legal Disclaimer
          </p>
          <p className="text-sm leading-relaxed text-zinc-400">
            THCA products are <span className="text-white">not legal in all states</span> and
            their legal status varies by location. Nothing on this site is legal advice.
            Customers are solely responsible for reviewing and complying with all applicable
            local, state, and federal laws and regulations before purchasing. You must be of
            legal age in your jurisdiction. This site is an independent promoter and is not
            affiliated with, endorsed by, or responsible for the products, pricing, or
            fulfillment of the linked brands.
          </p>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-6 border-t border-white/10 pt-10 md:flex-row md:items-center">
          <span className="font-display text-lg font-extrabold tracking-tighter text-white">
            THE<span className="text-[#ccff00]">/</span>DROP
          </span>
          <p className="font-mono-accent text-xs uppercase tracking-[0.15em] text-zinc-600">
            © {new Date().getFullYear()} The Drop. All referral links carry a 10%
            discount. Independent promoter — not affiliated statements.
          </p>
        </div>
      </div>
    </footer>
  );
};
